export default __webpack_public_path__ + "static/media/Taco Trio - proportioned_170.04578adb.jpg";